<template>
  <div class="AddForm">
    <el-dialog
      class="customDialog"
      title="新增"
      :visible.sync="isShow"
      @close="closeDialog"
      :close-on-press-escape = 'false'
      top="15vh"
      :close-on-click-modal = 'false'
    >
      <div class="formContainer">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
          <el-form-item :label="item.label+'：'" v-for="item in _columns" :key="item.id">
            <span slot="label" :title="item.label">{{item.label}}：</span>
            <el-input maxlength="20" show-word-limit v-model="dynamic[item.id]" @input="handelChange"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" :loading="true" v-if="loading"></el-button>
        <el-button type="primary" @click="submitForm()" v-else :disabled="disableBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addRowData } from '@/api/dataManagement'
export default {
  name: 'AddForm',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: null
    },
    tableId: {
      type: Number,
      default: 0
    }
  },
  components: { },
  data () {
    return {
      loading: false,
      ruleForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        region: [
          { required: true, message: '请选择活动区域', trigger: 'change' }
        ]
      },
      dynamic: {},
      disableBtn: true
    }
  },
  computed: {
    isShow: {
      get: function (v) {
        return this.show
      },
      set: function (v) {
        // 点击关闭按钮更新父组件传过来的参数为false
        this.$emit('update:show', v)
      }
    },
    _columns () {
      this.$nextTick(() => {
        this.columns.forEach((item) => {
          this.$set(this.dynamic, item.id, '')
        })
      })
      return this.columns
    }
  },
  watch: {
    data (newValue, oldValue) {

    }
  },
  methods: {
    submitForm () {
      this.loading = true
      const params = {
        tableId: this.tableId,
        values: []
      }
      Object.keys(this.dynamic).forEach(k => {
        params.values.push({
          propertyId: k,
          value: this.dynamic[k]
        })
      })
      addRowData(params).then(res => {
        if (res.code === 200) {
          this.$Message('success', res.msg || '操作成功！')
          this.$emit('refreshTable')
          this.isShow = false
          this.loading = false
        }
      }).catch(() => {
        this.loading = false
      })
    },
    cancel () {
      this.isShow = false
    },
    closeDialog () {
      this.loading = false
      this.$refs.ruleForm.resetFields()
      this.dynamic = this.$options.data().dynamic
      this.disableBtn = true
    },
    handelChange (v) {
      console.log(this.dynamic)
      // eslint-disable-next-line no-unused-vars
      let i = 0
      Object.keys(this.dynamic).forEach(k => {
        if (this.dynamic[k]) {
          i++
        }
      })
      if (i) {
        this.disableBtn = false
      } else {
        this.disableBtn = true
      }
    }
  },
  filters: {}
}
</script>

<style lang="scss">
  .AddForm{
    .el-form-item__label{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .customDialog{
      .el-dialog{
        width: 890px;
      }
    }
  }
</style>
<style lang="scss" scoped>
.formContainer{
  max-height: 400px;
  overflow: auto;
}
</style>
